import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { useDebounce } from '@uidotdev/usehooks';
import { useInvoiceSettingsQuery, setInvoiceSettingsQuery } from '~/lib/Queries';
import TextInputWithInlineLabel from '~/components/TextInputWithInlineLabel.jsx';

const InvoiceSettings = () => {
    const { data, isLoading } = useInvoiceSettingsQuery();
    const { save, isSaving } = useBusinessPostApi(`/invoices/settings`);
    const [settings, setSettings] = useState(data?.settings || {});
    const debouncedSettings = useDebounce(settings, 500);

    useEffect(() => {
        setSettings(data?.settings || {});
    }, [JSON.stringify(data?.settings)]);

    useEffect(() => {
        if (!data) {
            // Don't set data to nothing!
            return;
        }

        // Update query cache
        setInvoiceSettingsQuery({
            settings: settings,
        });

        // Save to backend
        save({
            settings: settings,
        }).then(results => {
            setInvoiceSettingsQuery(results);
        });
    }, [JSON.stringify(debouncedSettings)]);

    const handleDefaultDueDateChange = (value) => {
        setSettings({
            ...settings,
            default_due_date_days: value === '' ? '' : parseInt(value) || 0,
        });
    };

    if (isLoading) {
        return <div className="panel px-6 py-4">Loading...</div>;
    }

    return (
        <div className="mt-6">
            <div className="space-y-4">
                <div>
                    <div className="flex items-center gap-2">
                        <TextInputWithInlineLabel
                            label="Default Due Date"
                            type="number"
                            min="0"
                            value={settings.default_due_date_days ?? ''}
                            onChange={handleDefaultDueDateChange}
                            className="input w-48"
                            placeholder="30"
                            suffix={<span className="pr-4">days</span>}
                        />
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                        Invoices default to due date in this many days after invoice created
                    </p>
                </div>
            </div>

            {isSaving && (
                <div className="mt-4 text-sm text-gray-500">
                    Saving...
                </div>
            )}
        </div>
    );
};

export default InvoiceSettings;

